module.exports = __webpack_public_path__ + "img/logo.eeab9e1b.svg";